import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-homeModule",
  "use": "icon-homeModule-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-homeModule\">\n<circle cx=\"15\" cy=\"15\" r=\"14.25\" stroke=\"#818FB6\" stroke-width=\"1.5\" />\n<rect x=\"7\" y=\"9\" width=\"16\" height=\"1.5\" fill=\"#818FB6\" />\n<rect x=\"7\" y=\"14\" width=\"13\" height=\"1.5\" fill=\"#818FB6\" />\n<rect x=\"7\" y=\"19\" width=\"10\" height=\"1.5\" fill=\"#818FB6\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol